import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SignInButton = styled.div`
  display: inline-block;
  background: #3899EC;
  border: 1px solid #3899EC;
  color: white;
  width: 238px;
  border-radius: 2px;
  white-space: nowrap;
  text-align: left;
  text-decoration: none;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    opacity: 1;
    box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.25), inset 0px 1px 2px 0px transparent;
  }
`
const SignInLabel = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding-left: 25px;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
`
const GoogleLogo = styled.div`
  background: url('data:image/png;base64,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') #fff 50% 50% no-repeat;
  background-size: 18px;
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  height: 40px;
`

class SignInWithGoogle extends Component {
  render () {
    return (
      <SignInButton onClick={this.props.onClick}>
        <GoogleLogo />
        <SignInLabel>Sign in with Google</SignInLabel>
      </SignInButton>
    )
  }
}

SignInWithGoogle.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default SignInWithGoogle



// WEBPACK FOOTER //
// ./src/components/signin/SignInWithGoogle.js